
import { useState, useEffect } from "react"
import { loadStripe } from "@stripe/stripe-js"
import { useToast } from "@/hooks/use-toast"

export function useStripePayment(clientSecret: string | null) {
  const { toast } = useToast()
  const [stripe, setStripe] = useState<any>(null)
  const [elements, setElements] = useState<any>(null)
  const [initError, setInitError] = useState<string | null>(null)

  useEffect(() => {
    const initStripe = async () => {
      try {
        // Use environment variable for Stripe key
        const stripeKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'pk_live_51QXt8iLBB8IUFcuXPZSWXNM7MltR0svXGXCm8NUX6ejw22WYFXm8EuJJ4VyS3FmHk4PoPVX1A2pL6w7NvpoOgzyb007US7AFGr';
        console.log("Initializing Stripe with key:", stripeKey.substring(0, 8) + "...");
        
        const stripeInstance = await loadStripe(stripeKey)
        
        if (!stripeInstance) {
          throw new Error("Failed to initialize Stripe")
        }

        setStripe(stripeInstance)
      } catch (error) {
        console.error("Stripe initialization error:", error)
        setInitError(error instanceof Error ? error.message : "Failed to initialize payment system")
        toast({
          variant: "destructive",
          title: "Payment System Error",
          description: "Unable to initialize payment system. Please try again later.",
        })
      }
    }

    initStripe()
  }, [toast])

  useEffect(() => {
    if (!stripe || !clientSecret) return

    const elements = stripe.elements({
      clientSecret,
      appearance: {
        theme: 'stripe',
        variables: {
          colorPrimary: '#6b21a8',
          borderRadius: '8px',
          colorBackground: '#ffffff',
          colorText: '#1a1a1a',
          colorDanger: '#df1b41',
          fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
          spacingUnit: '4px',
          fontSizeBase: '16px'
        },
      },
    })

    const paymentElement = elements.create('payment', {
      layout: 'tabs',
      fields: {
        billingDetails: {
          name: 'auto',
          email: 'auto',
          address: {
            country: 'auto',
            postalCode: 'auto',
            line1: 'auto',
            line2: 'auto',
            city: 'auto',
            state: 'auto',
          },
        },
      },
    })
    
    paymentElement.mount('#payment-element')
    setElements(elements)

    return () => {
      paymentElement.destroy()
    }
  }, [stripe, clientSecret])

  return {
    stripe,
    elements,
    initError
  }
}
